import { render, staticRenderFns } from "./addAccount.vue?vue&type=template&id=65875ac4&scoped=true"
import script from "./addAccount.vue?vue&type=script&lang=js"
export * from "./addAccount.vue?vue&type=script&lang=js"
import style0 from "./addAccount.vue?vue&type=style&index=0&id=65875ac4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65875ac4",
  null
  
)

export default component.exports